import api from './apiClient'

export const familiarService = {
  // Dashboard y resumen
  getDashboard: async () => {
    try {
      const response = await api.get('/familiar/dashboard')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener dashboard' }
    }
  },

  getResumenPlan: async () => {
    try {
      const response = await api.get('/familiar/resumen_plan')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener resumen del plan' }
    }
  },

  getEstadisticasUso: async () => {
    try {
      const response = await api.get('/familiar/estadisticas_uso')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener estadísticas de uso' }
    }
  },

  getServiciosDisponibles: async () => {
    try {
      const response = await api.get('/familiar/servicios_disponibles')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener servicios disponibles' }
    }
  },

  // Traslados programados
  getTrasladosProgramados: async () => {
    try {
      const response = await api.get('/familiar/traslados_programados')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener traslados programados' }
    }
  },

  getTrasladoProgramado: async (id) => {
    try {
      const response = await api.get(`/familiar/traslados_programados/${id}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener traslado programado' }
    }
  },

  crearTrasladoProgramado: async (data) => {
    try {
      const response = await api.post('/familiar/traslado_programado', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al crear traslado programado' }
    }
  },

  actualizarTrasladoProgramado: async (id, data) => {
    try {
      const response = await api.put(`/familiar/traslado_programado/${id}`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al actualizar traslado programado' }
    }
  },

  cancelarTrasladoProgramado: async (id) => {
    try {
      const response = await api.delete(`/familiar/traslado_programado/${id}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al cancelar traslado programado' }
    }
  },

  // Límites y uso
  getLimitesDetalle: async () => {
    try {
      const response = await api.get('/familiar/limites_detalle')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener límites detallados' }
    }
  },

  getLimitesYUso: async () => {
    try {
      const response = await api.get('/familiar/limites_uso')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener límites y uso' }
    }
  },

  // Beneficios
  getBeneficios: async () => {
    try {
      const response = await api.get('/familiar/beneficios')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener beneficios' }
    }
  },

  getEstadoBeneficiosAdicionales: async () => {
    try {
      const response = await api.get('/familiar/estado_beneficios_adicionales')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener estado de beneficios adicionales' }
    }
  },

  getBeneficiosAdicionalesDisponibles: async () => {
    try {
      const response = await api.get('/familiar/beneficios_adicionales_disponibles')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener beneficios adicionales disponibles' }
    }
  },

  // Restricciones del plan
  getRestriccionesPlan: async () => {
    try {
      const response = await api.get('/restricciones_planes/por_plan/FAMILIAR/HELP')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener restricciones del plan' }
    }
  },

  getRestriccionesPorCategoria: async (categoria) => {
    try {
      const response = await api.get(`/restricciones_planes/categoria/${categoria}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener restricciones por categoría' }
    }
  },

  getDatosPlanCompleto: async (idPlan) => {
    try {
      const response = await api.get(`/planes/${idPlan}/beneficios_y_limites`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener datos completos del plan' }
    }
  },

  // Afiliados familiares
  getAfiliadosCompleto: async () => {
    try {
      const response = await api.get('/familiar/afiliados_completo')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener afiliados' }
    }
  },

  crearAfiliado: async (data) => {
    try {
      const response = await api.post('/familiar/afiliado', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al crear afiliado' }
    }
  },

  actualizarAfiliado: async (id, data) => {
    try {
      const response = await api.put(`/familiar/afiliado/${id}`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al actualizar afiliado' }
    }
  },

  desactivarAfiliado: async (id) => {
    try {
      const response = await api.delete(`/familiar/afiliado/${id}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al desactivar afiliado' }
    }
  },

  // Renovación y ampliación
  getOpcionesRenovacion: async () => {
    try {
      const response = await api.get('/familiar/opciones_renovacion')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener opciones de renovación' }
    }
  },

  solicitarRenovacion: async (data) => {
    try {
      const response = await api.post('/familiar/solicitar_renovacion', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al solicitar renovación' }
    }
  },

  getOpcionesAmpliacion: async () => {
    try {
      const response = await api.get('/familiar/opciones_ampliacion')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener opciones de ampliación' }
    }
  },

  ampliarServicios: async (data) => {
    try {
      const response = await api.post('/familiar/ampliar_servicios', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al ampliar servicios' }
    }
  },

  // Zonas protegidas
  getZonasProtegidas: async () => {
    try {
      const response = await api.get('/familiar/zonas_protegidas')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener zonas protegidas' }
    }
  },

  activarZonaProtegida: async (data) => {
    try {
      const response = await api.post('/familiar/activar_zona_protegida', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al activar zona protegida' }
    }
  },

  desactivarZonaProtegida: async (id) => {
    try {
      const response = await api.delete(`/familiar/desactivar_zona_protegida/${id}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al desactivar zona protegida' }
    }
  },

  // Orientación telefónica
  solicitarOrientacionTelefonica: async (data) => {
    try {
      const response = await api.post('/familiar/solicitar_orientacion_telefonica', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al solicitar orientación telefónica' }
    }
  },

  getHistorialOrientaciones: async () => {
    try {
      const response = await api.get('/familiar/historial_orientaciones')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener historial de orientaciones' }
    }
  },

  getOrientacionTelefonica: async (id) => {
    try {
      const response = await api.get(`/familiar/orientacion_telefonica/${id}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener orientación telefónica' }
    }
  },

  actualizarEstadoOrientacion: async (id, data) => {
    try {
      const response = await api.put(`/familiar/orientacion_telefonica/${id}/actualizar_estado`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al actualizar estado de orientación' }
    }
  },

  completarOrientacionTelefonica: async (id, data) => {
    try {
      const response = await api.put(`/familiar/orientacion_telefonica/${id}/completar`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al completar orientación telefónica' }
    }
  },

  calificarOrientacionTelefonica: async (id, data) => {
    try {
      const response = await api.put(`/familiar/orientacion_telefonica/${id}/calificar`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al calificar orientación telefónica' }
    }
  },

  cancelarOrientacionTelefonica: async (id, data) => {
    try {
      const response = await api.put(`/familiar/orientacion_telefonica/${id}/cancelar`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al cancelar orientación telefónica' }
    }
  },

  // Exámenes de laboratorio
  getExamenesDisponibles: async () => {
    try {
      const response = await api.get('/familiar/examenes_disponibles')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener exámenes disponibles' }
    }
  },

  solicitarExamen: async (data) => {
    try {
      const response = await api.post('/familiar/solicitar_examen', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al solicitar examen' }
    }
  },

  getResultadosExamenes: async () => {
    try {
      const response = await api.get('/familiar/resultados_examenes')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener resultados de exámenes' }
    }
  },

  // Médico a domicilio
  solicitarMedicoDomicilio: async (data) => {
    try {
      const response = await api.post('/familiar/medico_domicilio', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al solicitar médico a domicilio' }
    }
  },

  getHistorialMedicosDomicilio: async () => {
    try {
      const response = await api.get('/familiar/medicos_domicilio_historial')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener historial de médicos a domicilio' }
    }
  },

  // Urgencias
  solicitarUrgencia: async (data) => {
    try {
      const response = await api.post('/familiar/urgencia', data)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al solicitar urgencia' }
    }
  },

  getHistorialUrgencias: async () => {
    try {
      const response = await api.get('/familiar/urgencias_historial')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener historial de urgencias' }
    }
  },

  // Historial médico
  getHistorialMedico: async () => {
    try {
      const response = await api.get('/familiar/historial_medico')
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener historial médico' }
    }
  },

  getDetalleHistorialMedico: async (id) => {
    try {
      const response = await api.get(`/familiar/historial_medico/${id}`)
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Error al obtener detalle del historial médico' }
    }
  }
}